var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('TopNav',{attrs:{"showDetail":!_vm.showDetail}}),_c('Detail',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDetail),expression:"showDetail"}],attrs:{"fixed":_vm.showDetail}}),_c('SectionHot'),_c('Product'),_c('Free'),_c('Process'),_c('Service'),_c('Parnter'),_c('Set'),_c('Footer'),_c('Feedback')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }